import { createFileRoute } from "@tanstack/react-router";
import React, { Suspense, lazy } from "react";

// LL97 PM process view. The trailing-underscore `buildings_` segment is
// the established repo escape-hatch (identical to the legacy
// `routes/buildings_/$buildingId/ll97_/...` route): it keeps this route
// nested under `portal.tsx` (→ Tracker chrome: TrackerSidebar + gutter)
// but PREVENTS nesting under `routes/portal/buildings/$buildingId.tsx`
// (the BuildingDetail page, which renders WITHOUT an <Outlet/>). A
// plain-directory or dot-route child would make BuildingDetail the
// layout parent and never render this page. NO SiteHeader/backLink here
// — that is classic `/buildings` chrome; this surface is Tracker-native.
const Ll97ProcessPage = lazy(() => import("@/pages/Portal/Ll97Process/Page"));

interface Ll97ProcessSearch {
  // 4-digit year string, shape-validated only — NOT restricted to a
  // hardcoded "2024"/"2025" union. The server-known cycle set (read off
  // the portal codes projection) is the single source of truth for which
  // years actually resolve; see `resolveLl97Cycle` in
  // `pages/Portal/Ll97Process/dispatch.ts` (round 6, PRD v7 §3.3).
  cycle?: string;
  tab?:
    | "overview"
    | "team"
    | "schedule"
    | "documents"
    | "rdp"
    | "timeline"
    | "receipts";
}

const TABS = [
  "overview",
  "team",
  "schedule",
  "documents",
  "rdp",
  "timeline",
  "receipts",
];

const YEAR_RE = /^\d{4}$/;

export const Route = createFileRoute("/portal/buildings_/$buildingId/ll97")({
  validateSearch: (search: Record<string, unknown>): Ll97ProcessSearch => {
    const cycle =
      typeof search.cycle === "string" && YEAR_RE.test(search.cycle)
        ? search.cycle
        : undefined;
    const tab =
      typeof search.tab === "string" && TABS.includes(search.tab)
        ? (search.tab as Ll97ProcessSearch["tab"])
        : undefined;
    return { cycle, tab };
  },
  component: () => {
    const { buildingId } = Route.useParams();
    return (
      <Suspense fallback={null}>
        <Ll97ProcessPage buildingId={buildingId} />
      </Suspense>
    );
  },
});
